import { createAction } from '@reduxjs/toolkit';

const latestBlockIdUnset = createAction('board/clear-latest-block-id');

export { latestBlockIdUnset };
